module.exports = __webpack_public_path__ + "img/video.a672c02f.svg";